document.querySelectorAll('[data-awol-notify]').forEach(function (root) {
  var trigger = root.querySelector('[data-awol-notify-trigger]');
  var form = root.querySelector('[data-awol-notify-form]');

  if (!trigger || !form) return;

  trigger.addEventListener('click', function () {
    trigger.hidden = true;
    form.hidden = false;
    var emailInput = form.querySelector('input[type="email"]');
    if (emailInput) emailInput.focus();
  });
});
